import { FetchCMSTokensEndAction } from "../actions/FetchCMSTokens";
import { AppState } from "../state";

export function fetchCMSTokens(state: AppState, action: FetchCMSTokensEndAction): AppState {
    if (action.payload.error) {
        const errorMap = {
            ...state.errorMap,
            [action.type]: action.payload.error
        };

        return {
            ...state,
            errorMap
        };
    } else {
        const { appId, tokens } = action.payload;

        return {
            ...state,
            tokens: {
                ...state.tokens,
                [appId]: {
                    ...state.tokens[appId],
                    currentTokens: tokens
                }
            }
        };
    }
}
